var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var CommodityIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 64,
    glyphHeight: 56
  }), React.createElement("path", {
    d: "M47.6522 0.869568H16.3479L0.695679 28L16.3479 55.1304H47.6522L63.3044 28L47.6522 0.869568ZM36.9044 36.3478H27.0957L22.2331 28L27.0957 19.6522H36.9044L41.767 28L36.9044 36.3478ZM37.0505 15.4783H26.9496L20.9809 5.04348H42.9983L37.0296 15.4783H37.0505ZM23.4018 17.6904L18.6018 25.913H6.70611L17.4539 7.29739L23.4018 17.6904ZM18.6018 30.087L23.4018 38.3096L17.4539 48.7026L6.70611 30.087H18.6018ZM26.9496 40.5217H37.0505L43.0192 50.9565H21.0018L26.9705 40.5217H26.9496ZM40.5983 38.3096L45.3983 30.087H57.2939L46.5461 48.7026L40.5983 38.3096ZM45.3983 25.913L40.5983 17.6904L46.5461 7.29739L57.2939 25.913H45.3983Z"
  }));
};
export var CommodityIconGlyph = function (props) {
  return React.createElement(CommodityIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};